import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { twMerge } from 'tailwind-merge'

export type ButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants>

const buttonVariants = cva('button', {
  variants: {
    variant: {
      default: 'button-secondary',
      cta: 'button-primary',
      floating: 'button-floating',
      text: 'button-text !bg-inherit',
      ghost: 'button-ghost',
      nav: 'focus bg-white not-disabled:hover:bg-gray-10',
      listItem: 'bg-white not-disabled:hover:bg-gray-10 flex justify-between',
      rounded:
        'focus inline-flex gap-1.5 rounded-3xl border-2 bg-white text-black border-gray not-disabled:hover:border-border-interactive not-disabled:hover:bg-highlight',
      'rounded-filled':
        'focus inline-flex gap-1.5 rounded-3xl border-2 bg-black text-white disabled:text-white/50 border-black not-disabled:hover:border-border-interactive not-disabled:hover:bg-highlight not-disabled:hover:text-black',
      outline: 'button-outline',
      danger: 'button-danger',
      'outline-danger': 'button-outline-danger',
    },
    shape: {
      default: '',
      icon: 'button-icon',
    },
    size: {
      default: '',
      medium: 'button-medium',
      xl: 'button-xl',
      md: 'button-md',
      sm: 'button-sm',
    },
  },
  compoundVariants: [
    { variant: 'listItem', shape: 'default', className: 'w-full' },
    {
      variant: ['rounded', 'rounded-filled'],
      shape: 'default',
      className: '!py-1.5',
    },
  ],
  defaultVariants: {
    variant: 'default',
    size: 'default',
    shape: 'default',
  },
})

function Button({
  className,
  variant,
  size,
  shape,
  type = 'submit',
  ...props
}: ButtonProps) {
  return (
    <ButtonPrimitive
      data-slot="button"
      contentEditable={shape === 'icon' ? false : undefined}
      type={type}
      className={twMerge(buttonVariants({ variant, size, shape, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
